import { HotspotListItem } from "../HotspotListItem/HotspotListItem";
import { getHotspotNames } from "../../redux/selectors";
import { useSelector } from "react-redux";

export function HotspotList() {
  const hotspotNames = useSelector(getHotspotNames);
  return (
    <>
      {hotspotNames.map((name, index) => {
        return <HotspotListItem name={name} hotspotIndex={index} key={index} />;
      })}
    </>
  );
}
